import { isEmpty, kebabCase } from 'lodash';
import { useContext, useMemo } from 'react';

import { OfferItem, OffersPageContext, Skeleton } from 'components';

const OffersList = () => {
  const skeletonCount = 6;
  const { offersData, offersLoading, selectedCategory } = useContext(OffersPageContext);

  const filteredAndSortedOffers = useMemo(() => {
    if (isEmpty(offersData?.data?.[0]?.offers)) return [];

    return offersData.data[0].offers
      .filter((offer) => offer.offerCategories.some((category) => kebabCase(category.name) === selectedCategory))
      .sort((a, b) => a.order - b.order);
  }, [offersData, selectedCategory]);

  return (
    <>
      {offersLoading && (
        <div className="mb-12 grid gap-4 lg:gap-8">
          {Array.from({ length: skeletonCount }, (_, index) => (
            <div className="flex flex-col gap-y-8 relative" key={`skeleton-offer${index}`}>
              <div className="offer-card-container ">
                <div className="col-span-4 lg:col-span-3 lg:aspect-video">
                  <Skeleton type="text" classNames="h-full w-full object-cover rounded-xl" />
                </div>
                <div className="offer-card">
                  <div className="lg:w-3/5">
                    <div>
                      <Skeleton type="text" classNames="h-8 w-48 " />
                    </div>
                    <Skeleton type="text" classNames="h-20 w-full " />
                  </div>

                  <div className="flex-center-center flex-col gap-4 mt-4 lg:flex lg:items-end">
                    <Skeleton type="text" classNames="h-8 w-48 " />
                    <Skeleton type="text" classNames="h-8 w-48 " />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {!offersLoading && !isEmpty(filteredAndSortedOffers) && (
        <div className="mb-12 grid gap-4 lg:gap-8">
          {filteredAndSortedOffers.map((offer) => (
            <OfferItem offer={offer} key={`card-offer-${offer.id}`} />
          ))}
        </div>
      )}
    </>
  );
};

export default OffersList;
